import React, { useEffect, useState } from "react";
import "./Blog_outer.css";
import Blog_outer_tab from "./Blog_outer_tab/Blog_outer_tab";
import { Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Blog_outer_tab_Posts from "./Blog_outer_tab_Posts/Blog_outer_tab_Posts";
import Blog_outer_tab_Social_Media from "./Blog_outer_tab_Social_Media/Blog_outer_tab_Social_Media";
import Blog_pagination_holder from "./Blog_pagination_holder/Blog_pagination_holder";
import Blog_outer_card from "../../Common-Component/Blog_outer_card/Blog_outer_card";
import Breadcrumb_comp from "../../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import { getblog } from "../../../features/blog/Slice";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";

function Blog_outer() {
  const [searchText, setSearchText] = useState("");

  const [selectedCategory, setSelectedCategory] = useState(null);
  const blog = useSelector((state) => state.blog.addBlog);
  const dispatch = useDispatch();
 

  useEffect(() => {
    dispatch(getblog({ id: selectedCategory, name: searchText }));
  }, [dispatch, selectedCategory, searchText]);

  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 4; // Show 4 posts per page

  const blogPosts = [
    {
      imgSrc: "/assets/Images/Blog/Blog_outer/Blog_img_1.png",
      innerText: "How to Choose the Best Standard Business Card for Your Needs",
      date: "22 Nov 2024",
      description:
        "A business card is more than just a piece of paper—it’s a reflection of your brand and professionalism...",
    },
  ];

  // Calculate total pages
  const totalPages = Math.ceil(blogPosts.length / postsPerPage);

  // Get current page's blog posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogPosts.slice(indexOfFirstPost, indexOfLastPost);

  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "Blog" }, // No link for the last item (active)
  ];

  return (
    <>
      <div className="breadcrump_holder">
        <div className="Breadcrumb_div">
          <Breadcrumb_comp data={breadcrumbData} />
        </div>
      </div>
      <section className="Blog_outer">
        <div className="row">
          <div className="col-md-4 col-sm-6 Header">
            <div className="header_icon_search_holder">
              <Form className="header_search_holder">
                <InputGroup className="searchbar_holder">
                  <Form.Control
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search..."
                    aria-label="Search..."
                    aria-describedby="basic-addon1"
                  />
                  <InputGroup.Text id="basic-addon1">
                    <FontAwesomeIcon
                      className="header_icon"
                      icon={faMagnifyingGlass}
                    />
                  </InputGroup.Text>
                </InputGroup>
              </Form>
            </div>

            <Blog_outer_tab
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
            />
            <Blog_outer_tab_Posts />
            <Blog_outer_tab_Social_Media />
          </div>

          <div className="col-md-8  col-sm-6">
            <div className="cards_holder">
              <div className="row">
                {blog?.data?.map((post, index) => (
                  <div className="col-md-6" key={index}>
                    <Blog_outer_card
                      post={post.id}
                      imgSrc={process.env.REACT_APP_IMG_URL + post?.image}
                      innerText={post.name}
                      date={post.createdAt}
                      description={parse(post.description) || ""}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Pagination Component */}
            <Blog_pagination_holder
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog_outer;
